export enum OverrideType {
  ForceBlackout = 1,
  ForceStream
}
